import type { ImgHTMLAttributes } from "react";
import manifest from "@/data/image-manifest.json";

export default function OptimizedImage({ src, width, height, loading = "lazy", decoding = "async", ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  const image = manifest[src as keyof typeof manifest];
  return <img {...props} src={image?.src ?? src} width={width ?? image?.width ?? 600} height={height ?? image?.height ?? 400} loading={loading} decoding={decoding} />;
}
